// 1) Enum 1:1 z backendem
export enum CompanyConsentTypeEnum {
    TermsOfService = 1,
    PrivacyPolicy = 2,
    GdprDataProcessing = 3,
    MarketingCommunications = 4,
    PublicCompanyProfile = 5,
    BrandAssetsLicense = 6,
}

// 2) Teksty PL/EN + "required"
type Lang = 'pl' | 'en';

export const COMPANY_CONSENT_TEXT: Record<
    CompanyConsentTypeEnum,
    {
        label: Record<Lang, string>;
        description: Record<Lang, string>;
        required: boolean;
    }
> = {
    [CompanyConsentTypeEnum.TermsOfService]: {
        label: { pl: 'Regulamin', en: 'Terms of Service' },
        description: {
            pl: 'Akceptacja regulaminu jest wymagana do publikacji profilu w marketplace.',
            en: 'Acceptance is required to publish your company profile in the marketplace.',
        },
        required: true,
    },
    [CompanyConsentTypeEnum.PrivacyPolicy]: {
        label: { pl: 'Polityka prywatności', en: 'Privacy Policy' },
        description: {
            pl: 'Potwierdzenie zapoznania się z zasadami przetwarzania danych.',
            en: 'Confirmation that you have read how we process your data.',
        },
        required: true,
    },
    [CompanyConsentTypeEnum.GdprDataProcessing]: {
        label: { pl: 'Przetwarzanie danych (RODO)', en: 'GDPR Data Processing' },
        description: {
            pl: 'Zgoda na przetwarzanie danych zgodnie z RODO.',
            en: 'Consent to processing personal data in accordance with GDPR.',
        },
        required: true,
    },
    [CompanyConsentTypeEnum.MarketingCommunications]: {
        label: { pl: 'Komunikacja marketingowa', en: 'Marketing Communications' },
        description: {
            pl: 'Zgoda na otrzymywanie informacji o nowościach i ofertach (opcjonalne).',
            en: 'Receive news and offers (optional).',
        },
        required: false,
    },
    [CompanyConsentTypeEnum.PublicCompanyProfile]: {
        label: { pl: 'Publiczny profil firmy', en: 'Public Company Profile' },
        description: {
            pl: 'Zgoda na publiczne wyświetlanie podstawowych informacji firmy w marketplace.',
            en: 'Allow basic company information to be publicly visible in the marketplace.',
        },
        required: true,
    },
    [CompanyConsentTypeEnum.BrandAssetsLicense]: {
        label: { pl: 'Licencja na materiały brandowe', en: 'Brand Assets License' },
        description: {
            pl: 'Pozwala używać nazwy i logotypu w listingach i materiałach promocyjnych.',
            en: 'Allow use of your company name and logo in listings and promotional materials.',
        },
        required: false,
    },
} as const;

// 3) Helpery do pobierania tekstów
export const consentLabel = (
    type: CompanyConsentTypeEnum,
    lang: Lang = 'pl'
) => COMPANY_CONSENT_TEXT[type].label[lang];

export const consentDescription = (
    type: CompanyConsentTypeEnum,
    lang: Lang = 'pl'
) => COMPANY_CONSENT_TEXT[type].description[lang];

export const consentRequired = (type: CompanyConsentTypeEnum) =>
    COMPANY_CONSENT_TEXT[type].required;

// 4) Lista pod Select/Checkboxy w danym języku
export const CONSENT_DEFS = (lang: Lang = 'pl') =>
    (Object.values(CompanyConsentTypeEnum) as number[])
        .filter((v): v is CompanyConsentTypeEnum => typeof v === 'number')
        .map((type) => ({
            type,
            label: consentLabel(type, lang),
            description: consentDescription(type, lang),
            required: consentRequired(type),
        }));
